<template>
	<div>
		<div :class="isradius?'cont m-t setradis':'cont m-t'">
			<div class="navscroll"    v-for="(headnavdto,index) in HeadNavDtoList" :key="index" >
				<div>
					<div class="navjb" :style="'background-image: linear-gradient(to bottom,'+headnavdto.beforceBackColor+','+headnavdto.afterBackColor+')'" >
						<div class="navjb-wz">
							<div class="navjb-tit-image" >
								<img  v-lazy="$baseurl+headnavdto.logoPath" />
							</div>
							<span class="navjb-tit" :style="headnavdto.titColor?'color:'+headnavdto.titColor:''">{{headnavdto.headNavName}}</span>
						</div>
						
						<div class="navdetail">
							<div :class="setclass(headnavdto.headNavDetailList,heanavdetail)" v-for="(heanavdetail,dindex) in headnavdto.headNavDetailList" :key="dindex"   @click="setindex(heanavdetail,index)" >
									<div class="navdetail-cont-wz">
										<div class="navdetail-cont-tit" :style="heanavdetail.checked?'color:'+headnavdto.checkColor:''">
											{{heanavdetail.name}}
										</div>
										<div class="navdetail-cont-stit" :style="heanavdetail.checked?'background-color:'+headnavdto.checkColor:''" >
											{{heanavdetail.content}}
										</div>
									</div>
							</div>
						</div>
					</div>
					
					<div v-for="(zheanavdetail,zdindex) in headnavdto.headNavDetailList"  :key="zdindex">
						<div v-if="zheanavdetail.checked">
							 <div   class="navswiper" v-for="(heanavdetailinfo,iindex) in zheanavdetail.headNavDetailInfoDtoList" :key="iindex" @click="navdetail(heanavdetailinfo)">
					     	<div class="navswiper-item">
					     		<img v-lazy="$baseurl+heanavdetailinfo.picPath" />
					     	</div>
					     	<div :class="isradius?'navswiper-footer setbar':'navswiper-footer'">
					     		<div class="navswiper-footer-Price"> 
					     			￥{{heanavdetailinfo.lowPrice}}
					     			<span class="navswiper-footer-Price-wz"> 起</span>
					     		</div>
					     		<div class="navswiper-footer-btns">
					     			<button class="navswiper-footer-btn" :style="'background-color:'+headnavdto.checkColor">下单提货</button>
					     		</div>
					     	</div>
					     </div>
						</div>
					</div> 
					
						
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import text from '../page/text.vue';
	export default {
  components: { text },
        name:'myhead',
		props:{
			HeadNavDtoList:{
				type: Array,
				default:()=>[]
			},
			isradius:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
				
			}
		},
		methods: {
			setclass(headNavDetailList,heanavdetail)
			{
				var calssstr="navdetail-cont";
				if(headNavDetailList.length==1)
				{
					calssstr="navdetail-cont-x";
				}
				if(headNavDetailList.length==2)
				{
					calssstr="navdetail-cont-y";
				}

				if(heanavdetail.checked)
				{
					calssstr+=" active";
				}
				return calssstr;

			},
			setindex(item,index)
			{
				this.$emit('setnavindex',item,index);
			},
			navdetail(item)
			{
				
				if(item.goodsNum==1)
				{
					
                    let productSku = item.productSku;
					this.$router.push({path:'/product/'+productSku});
				}
				else
				{
					//设置数据缓存
					
                    let id=item.id;
                    this.$router.push({path:'/headnavdetail',query:{id:id}})
					
				}
			}
			
		}
	}
</script>

<style lang="scss" scoped>
	
	.navscroll{
		font-size: 14px;
		background-color: #ffffff;
		padding-bottom: 10px;
		margin-bottom: 8px;
		border-radius: 6px;
	}
	.scollertop{
		position: fixed; 
		top: 0;
		left: 0;
		right: 0;
		z-index: 1000;
		background: white;
		padding-top: 10px;
		padding-bottom: 10px;
	}
	.navjb{
		border-radius: 11px;
	}
	.navjb-wz{
		line-height: 45px;
		padding-left: 48px;
		position: relative;
	}
	.navjb-tit-image{
		position: absolute;
		top: 4px;
		left: 6px;
		width: 35px;
		height: 35px;
	}

	.navjb-tit
	{
		font-weight: bold;
	}
	
	.navjb-tit-image img{
		width: 100%;
		height: 100%;
	}
	.navdetail{
		text-align: center;
		padding-bottom: 5px;
	}
	.navdetail-cont{
		width: 24%;
		display: inline-block;
		border-right: 1px solid #C8C7CC;
	}
	.navdetail-cont-y
	{
		width: 49%;
		display: inline-block;
		border-right: 1px solid #C8C7CC;
	}
	.navdetail-cont-x{
		display: inline-block;
	}
	.navdetail-cont-wz{
		display: inline-block;
	}
	.navdetail-cont:last-of-type
	{
		border-right:none;
	}
	.navdetail-cont-y:last-of-type{
		border-right:none;
	}
	.navdetail-cont-tit{
		font-size: 14px;
		font-weight: bold;
	}
	.navdetail-cont-stit{
		font-size: 11px;
		color:#828282;
	}
	.active .navdetail-cont-stit
	{
		border-radius: 10px;
		color: white;
		padding: 1px 10px 1px 10px;
	}
	.navswiper{
		position: relative;
		color: white;
	}
	.navswiper-item{
		width: 350px;
		height: 200px;
		margin: 7px auto 0px;
	}
	.navswiper-item img{
		width: 100%;
		height: 100%;
		border-radius: 8px;
		
	}
	.navswiper-footer{
		position: absolute;
		bottom: 0;
		left: 13px;
		right: 13px;
		height: 57px;
		background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(255, 255, 255, 0.04));
		border-radius: 0 0 10px 10px;
	}
	
	.setbar
	{
		left: 2px;
		right: 2px;
	}
	
	.navswiper-footer-btns
	{
		position: absolute;
		right: 27px;
		bottom: 19px;
	}
	.navswiper-footer-btn{
		background-color: #F0AD4E;
		border-radius: 5px;
		color: white;
		font-size: 13px;
		font-weight: bold;
		padding: 10px 15px;
        border: none;
	}
	.navswiper-footer-btn::after
	{
		border: none;
	}
	.navswiper-footer-Price{
		bottom: 20px;
		position: absolute;
		left: 28px;
		font-size: 22px;
		font-weight: bold;
		
	}
	.navswiper-footer-Price-wz{
		font-size: 12px;
		font-weight: normal;
	}
	
	.m-t{
		margin-top: 8px;
	}
	.setradis
	{
		margin-left: 10px;
		margin-right: 10px;
		
	}
</style>
